const { VictoryPie } = require('victory');

const TransaccionesSalud = () => {
  return (
    <>
      <div
        className="flex-col bg-white m-10 rounded-lg mt-0 border-r border-b border-l border-gray-400 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r border-gray-400"
        style={{ margin: '20px 10px 10px 10px', height: '32vh' }}
      >
        <p className="p-10 font-medium">Transacciones Salud</p>
        <div style={{ height: '85%', margin: '10px' }}>
          <VictoryPie
            colorScale={['tomato', 'orange', 'gold', 'cyan', 'navy']}
            style={{ labels: { fontSize: 16, fontWeight: 'bold', height: '75%' } }}
            data={[
              {
                x: '6.2%',
                y: 6.2,
                color: '#5FEA2D',
              },
              {
                x: '4.0%',
                y: 4.0,
                color: '#41E1F8',
              },
              {
                x: '3.1%',
                y: 3.1,
                color: '#F5A305',
              },
              {
                x: '3.1%',
                y: 3.1,
                color: '#FA4646',
              },
              {
                x: '4.0%',
                y: 4.0,
                color: '#FDC541',
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};

export default TransaccionesSalud;
